export default ()=>{
  return(`

    .MaxHeight {
      max-height: 320px;
      overflow-y: auto;
    }
  `)
}
